//==============================
// Newsletter Popup
//==============================

var newsletterPopup = $('.newsletter-popup');

function showNewsletter(delay) {
  if (Cookies.get("newsletter") == "SET") {} else {
    setTimeout(function() {
      newsletterPopup.removeClass('hidden');
    }, delay);
    setTimeout(function() {
      newsletterPopup.focus();
    }, delay + 100);
  }
}

function hideNewsletter() {
  Cookies.set("newsletter", "SET", { expires: 7 });
  newsletterPopup.addClass('hidden');
  setTimeout(function() {
    $('.header').focus();
  }, 1);
}

$(window).on('load', function() {
    if(body.hasClass('home')) {
      showNewsletter(2000);
    } else {
      showNewsletter(0);
    }
});

$('.js-newsletter-popup-close').click(function() {
  hideNewsletter();
  return false;
});

newsletterPopup.click(function() {
  hideNewsletter();
});

newsletterPopup.find('.button').click(function() {
  hideNewsletter();
});

$('.newsletter-popup-inner').click(function(e) {
  e.stopPropagation();
});
